import {
    getListQuestion,
    createQuestions,
    editQuestions,
    showEditQuestions,
    deleteQuestions, getListAllQuestion,
    importQuestion,
    exportQuestion,
    getListTags,
} from "./../api.js";
export const state = {
    questionResponse: {},
    questionAllResponse: {},
    editQuestion: '',
    responseQuestion: '',
    explain: '',
    explain_path: '',
    explain_img_preview: '',
    explain_pdf_preview: '',
    changeListTags: ''
};

export const getters = {
    questionResponse: state =>
        state.questionResponse ? state.questionResponse.data : [],
    questionAllResponse: state =>
        state.questionAllResponse ? state.questionAllResponse.data : [],
    pagination: state => state.questionResponse,
    explain: state => state.explain,
    explain_path: state => state.explain_path,
    explain_img_preview: state => state.explain_img_preview,
    explain_pdf_preview: state => state.explain_pdf_preview,
    responseQuestion: state =>
        state.responseQuestion ? state.responseQuestion.data : [],
    changeListTags: state => state.changeListTags ? state.changeListTags.data : []
};

export const mutations = {
    getQuestion(state, data) {
        state.questionResponse = data;
    },
    getAllQuestion(state, data) {
        state.questionAllResponse = data;
    },
    getEditQuestion(state, data) {
        state.editQuestion = data;
    },
    getExplain(state, data) {
        state.explain = data;
    },
    getExplainPath(state, data) {
        state.explain_path = data;
    },
    getExplainImgPreview(state, data) {
        state.explain_img_preview = data;
    },
    getExplainPdfPreview(state, data) {
        state.explain_pdf_preview = data;
    },
    delExplain(state) {
        state.explain = '';
    },
    delExplainPath(state) {
        state.explain_path = '';
    },
    delExplainPreview(state) {
        state.explain_img_preview = '';
        state.explain_pdf_preview = '';
    },
    getResponseQuestion(state, data) {
        if (!data.error) {
            state.responseQuestion = data.data;
        } else {
            state.responseQuestion = data.error.response.data;
        }
    },
    getChangeListTags(state, data){
        state.changeListTags = data;
    }
};

export const actions = {
    async getQuestion({commit}, query) {
        let data = await getListQuestion(query);
        commit("getQuestion", data);
    },
    async getAllQuestion({commit},params) {
        let data = await getListAllQuestion(params);
        commit("getAllQuestion", data);
    },
    async setExplain({commit}, params) {
        commit("getExplain", params.explain);
        commit("getExplainPath", params.explain_path);
        commit("getExplainImgPreview", params.explain_img_preview);
        commit("getExplainPdfPreview", params.explain_pdf_preview);
    },
    async createQuestion({commit}, params) {
        let isSuccess = await createQuestions(params);
        commit("getResponseQuestion", isSuccess);
    },

    async showEditQuestion({ commit }, params) {
        let data = await showEditQuestions(params);
        data.data.idQues = (params)

        commit("getEditQuestion", data);
    },
    async editQuestion({ commit }, params) {
        let isSuccess = await editQuestions(params);
        commit("getResponseQuestion", isSuccess);
    },
    async deleteQuestion({ commit }, params) {
        let isSuccess = await deleteQuestions(params);
        commit("getResponseQuestion", isSuccess);
    },
    async deleteExplain({ commit }) {
        commit("delExplain");
        commit("delExplainPath");
        commit("delExplainPreview");
    },
    async importQuestion({ commit },params){
        let isSuccess = await importQuestion(params);
        commit("getResponseQuestion", isSuccess);
    },
    async exportQuestion({ commit }, params){
        let isSuccess = await exportQuestion(params);
        commit("getResponseQuestion", isSuccess);
    },

    async changeListTags({ commit }, params){
        let isSuccess = await getListTags(params);
        commit("getChangeListTags", isSuccess);
    }

};
